import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, renderSlot as _renderSlot, isRef as _isRef, vModelDynamic as _vModelDynamic, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full relative" }
const _hoisted_2 = {
  key: 0,
  for: "props.name",
  class: "mb-5 font-medium"
}
const _hoisted_3 = {
  key: 0,
  class: "text-error"
}
const _hoisted_4 = {
  key: 1,
  class: "absolute top-[12px] ml-4"
}
const _hoisted_5 = ["id", "name", "type", "min", "placeholder", "autocomplete", "disabled"]

import { watch, computed } from "vue"
  import { useField } from "vee-validate"
  import errorLabel from "./errorLabel.vue"

  interface Props {
    placeholder?: string
    type?: string
    id?: string
    name: string
    modelValue: string | number
    inputClass?: string
    label?: string
    labelRequired?: boolean
    icon?: boolean
    autocomplete?: string
    min?: number
    disabled?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InputTemplate',
  props: {
    placeholder: null,
    type: null,
    id: null,
    name: null,
    modelValue: null,
    inputClass: null,
    label: null,
    labelRequired: { type: Boolean },
    icon: { type: Boolean },
    autocomplete: null,
    min: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    placeholder?: string
    type?: string
    id?: string
    name: string
    modelValue: string | number
    inputClass?: string
    label?: string
    labelRequired?: boolean
    icon?: boolean
    autocomplete?: string
    min?: number
    disabled?: boolean
  }

  
  const { value, errorMessage, handleChange } = useField(props.name, {
    validateOnValueUpdate: false,
  })

  const icon = computed(() => props.icon || false)
  const autocomplete = computed(() => props.autocomplete || "on")

  const validationListeners = computed(() => {
    if (!errorMessage.value) {
      return {
        blur: handleChange,
        change: handleChange,
        input: (e: unknown) => handleChange(e, false),
      }
    }

    return {
      blur: handleChange,
      change: handleChange,
      input: handleChange,
    }
  })

  watch(
    () => props.modelValue,
    (val) => {
      if (val) value.value = val
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.label?.length)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(props.label) + " ", 1),
          (props.labelRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(icon))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", _mergeProps({
      id: __props.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      name: props.name,
      type: __props.type || 'text',
      min: __props.min,
      class: ["h-[45px] w-full rounded-xl focus:ring-0 outline-none transition ease-out duration-200 text-black bg-light-gray-100", [props.inputClass, _unref(icon) ? 'pl-12' : 'pl-5']],
      placeholder: __props.placeholder,
      autocomplete: _unref(autocomplete),
      disabled: __props.disabled
    }, _toHandlers(_unref(validationListeners), true)), null, 16, _hoisted_5), [
      [_vModelDynamic, _unref(value)]
    ]),
    _createVNode(errorLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(errorMessage)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})